export default __webpack_public_path__ + "static/media/indicator-quote3.f9872583.svg";